//ReadBook.js
import React, { useCallback, useState, useEffect, useHistory, useMemo } from "react";
import { Link } from 'react-router-dom';

import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSwipeable } from "react-swipeable";
import Tooltip from '../../components/utils/Tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlay,
  faPlayCircle,
  faStop,
  faVolumeMute,
  faVolumeUp,
  faSpinner,
  faMusic,
  faCommenting,
  faEdit,
  faLink,
  faGears,
  faComment,
  faComments,
  faTimes,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import Speech from "speak-tts";
import "./styles/ReadBook.css";
import SpeechInputComponent from '../../components/SpeechInputComponent';
import AILightComponent from '../../components/AILightComponent';
import HandwritingToText from './HandwritingToText';
import HandwrittenNote from './HandwrittenNote';
// import MathOCR from './MathOCR';
// ✅ Correct path matching your public folder structure
const backgroundMusic = process.env.PUBLIC_URL + '/assets/sounds/AnimalMovieRingtone.mp3';

import generateCommentsPDF from "./GenerateCommentsPDF"; 

const ReadBook = () => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const location = useLocation();

  // Retrieve initial state from location or fallback to an empty object
  const [initialState, setInitialState] = useState(() => location.state || {});

  // Ensure userId is updated correctly
  const [userId, setUserId] = useState(() => authState.user._id);
  const [userName, setUserName] = useState(() => authState.user.name);

  // Initialize state for savedBookMasterIdFromState
  const [savedBookMasterIdFromState, setSavedBookMasterIdFromState] = useState(() => initialState.bookMasterId || '');

  // Initialize state for bookMasterId
  const [bookMasterId, setBookMasterId] = useState(() => initialState.bookMasterId || savedBookMasterIdFromState);

  // Fallback to default values if state properties are undefined
  const bookCollectionName = initialState.bookCollectionName || "defaultCollectionName";
  const pageNumber = initialState.lastPageRead || 1;
  const bookPages = initialState.bookPages || [];
  const isChildren = initialState.isChildren || 0;

  // console.log("bookMasterId:", bookMasterId, " ", bookCollectionName);

  useEffect(() => {
    // Any logic that needs to run on component mount or when dependencies change
    // Avoid updating state here that would cause a dependency loop

    // console.log("userId:", userId);
    // console.log("bookMasterId:", bookMasterId);

  }, [userId, bookMasterId]); // Only run when userId or bookMasterId changes

  
  const [numberOfPages, SetNumberOfPages] = useState(bookPages);
  const [pageContent, setPageContent] = useState("");
  const [splText, setSplText] = useState("");
  const [bookTitle, setBookTitle] = useState("");
  const [currentPageNumber, setCurrentPageNumber] = useState(pageNumber);
  const [hasSpeech, setHasSpeech] = useState(0);
  const [hasMusic, setHasMusic] = useState(0);
  const [hasVideo, setHasVideo] = useState(0);
  const [videoUrl, setVideoUrl] = useState(0);
  const [isBase64Audio, setIsBase64Audio] = useState(0);
  const [base64Audio, setBase64Audio] = useState(false);

  const [isPageImage, setIsPageImage] = useState(false);
  const [pageImageURL, setPageImageURL] = useState('');
  const [splTextLang, setSplTextLang] = useState('');

  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [isAudioNotes, setIsAudioNotes] = useState(false);

  const [readFromSplText, setReadFromSplText] = useState(0);
  const [musicAudio] = useState(new Audio(backgroundMusic));
  const [pageCount, setPageCount] = useState(bookPages);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const [dateRead, setDateRead] = useState(new Date());
  // console.log(dateRead);
  const [pageLoadTime, setPageLoadTime] = useState(null);
  const [readTimeInMiliseconds, setReadTimeInMiliseconds] = useState(0);
  const [readingRemarks, setReadingRemarks] = useState("");
  const [isLogSaved, setIsLogSaved] = useState(true);
  const [isInteracted, setIsInteracted] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [notesType, setNotesType] = useState("Quick Notes");
  const [userCommentTitle, setUserCommentTitle] = useState("");
  const [userCommentDetails, setUserCommentDetails] = useState("");
  const [selectedLangCode, setSelectedLangCode] = useState('en-US');
  const [isImportantChecked, setIsImportantChecked] = useState(false);
  const [moreInputsChecked, setMoreInputsChecked] = useState(false);
  const [isMoreInputs, setIsMoreInputs] = useState(false);

  const [showMessage, setShowMessage] = useState(false);

  const [listLink, setListLink] = useState(false);
  const [addNewLink, setAddNewLink] = useState(false);
  const [closeLink, setCloseLink] = useState(false);

  const [linkName, setLinkName] = useState("");
  const [linkPageName, setLinkPageName] = useState("");
  const [linkTitle, setLinkTitle] = useState("");
  const [linkAddress, setLinkAddress] = useState("");

  const [isVideoChecked, setIsVideoChecked] = useState(false);
  const [linkDetails, setLinkDetails] = useState("");
  const [bookLinkSaved, setBookLinkSaved] = useState(false);
  const [bookLinkSavedMsg, setBookLinkSavedMsg] = useState(false);
  const [savedBookLinkMsg, setSavedBookLinkMsg] = useState('');
  const [bookLinkClicked, setBookLinkClicked] = useState(false);
  const [bookLinkCloseClicked, setBookLinkCloseClicked] = useState(false);
  const [bookLinkToBeDisabled, setBookLinkToBeDisabled] = useState(false);
  const [saveBookLinkToBeDisabled, setSaveBookLinkToBeDisabled] = useState(false);
  const [saveBookLinkClicked, setSaveBookLinkClicked] = useState(false);

  const [elapsedTime, setElapsedTime] = useState(0);
  const [error, setError] = useState(false);
  const [commentListFetched, setCommentListFetched] = useState(false)
  const [commentData, setCommentData] = useState([]);
  const [postCommentClicked, setPostCommentClicked] = useState(false);
  const [postedComment, setPostedComment] = useState(false);
  const [errors, setErrors] = useState();
  const [userComment, setUserComment] = useState('');
  const [postedCommentMsg, setPostedCommentMsg] = useState('');
  const [isVisibleToAllChecked, setIsVisibleToAllChecked] = useState(false);
  const [isConversationalNotes, setIsCoversationalNotes] = useState(false);

  const [notesRemarks, setNotesRemarks] = useState('');
  const [sortTags, setSortTags] = useState('');
  const [subjectName, setSubjectName] = useState('');
  const [bookName, setBookName] = useState('');
  const [chapter, setChapter] = useState('');
  const [chapterSection, setChapterSection] = useState('');
  const [chapterSubSection, setChapterSubSection] = useState('');
  const [bookPageNumber, setBookPageNumber] = useState('');
  const [institution, setInstitution] = useState('');
  const [teacherName, setTeacherName] = useState('');
  const [studyClass, setStudyClass] = useState('');
  const [sectionName, setSectionName] = useState('');
  const [studySession, setStudySession] = useState('');
  const [isSelfstudyChecked, setIsSelfstudyChecked] = useState(false);
  const handleIsSelfstudyCheckboxChange  = () => {
    setIsSelfstudyChecked(true);
  };

  const [postToBeDisabled, setPostToBeDisabled]=useState(false);
  const [readCommentClicked,setReadCommentClicked]=useState(false);
  const [isEditCommentClicked, setIsEditCommentClicked] = useState(false);
  const [postCloseClicked, setPostCloseClicked] = useState(false);
  const [readCommentCloseClicked, setReadCommentCloseClicked] = useState(false);
  const [settingsClicked, setSettingsClicked] = useState(false);
  const [settingsClosed, setSettingsClosed] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en-US");
  const [rate, setRate] = useState(1.0);
  const [pitch, setPitch] = useState(1.0);
  const [volume, setVolume] = useState(1.0);
  const [isContinuousAutoPageReadChecked, setIsContinuousAutoPageReadChecked] = useState(false);
  const [fromPageNumber, setFromPageNumber] = useState(1);
  const [toPageNumber, setToPageNumber] = useState(1);
  const [selectedNeuralVoice, setSelectedNeuralVoice] = useState('');
  const [selectedStandardVoice, setSelectedStandardVoice] = useState('');
  const [selectedExpressiveVoice, setSelectedExpressiveVoice] = useState('');
  const [selectedAccent, setSelectedAccent] = useState('');
  const [selectedCharacterVoice, setSelectedCharacterVoice] = useState('');
  const [isVoiceNotesEnabled, setIsVoiceNotesEnabled] = useState('');
  const [isSmartSpeakerEnabled, setIsSmartSpeakerEnabled] = useState('');
  const [isHandWrittenTextInputEnabled, setIsHandWrittenTextInputEnabled] = useState('');
  const [isHandWrittenFormulaInputEnabled, setIsHandWrittenFormulaInputEnabled] = useState('');
  const [isHandwritingVisible, setIsHandwritingVisible] = useState(false);
  const [isMathOCRVisible, setIsMathOCRVisible] = useState(false);

  const handleRateChange = (e) => setRate(parseFloat(e.target.value));
  const handleVolumeChange = (e) => setVolume(parseFloat(e.target.value));
  const handlePitchChange = (e) => setPitch(parseFloat(e.target.value));

  const [isCheckedAISupport, setIsCheckedAISupport] = useState(false);
  const [showMicrophoneAlert, setShowMicrophoneAlert] = useState(false);

  const handleToggleHandwriting = () => {
    setIsHandwritingVisible((prev) => !prev);
  };
  
  const handleOpenHandwriting = () => {
    setIsHandwritingVisible(true);
  };

  const handleCloseHandwriting = () => {
    setIsHandwritingVisible(false);
  };

  const handleOpenMathOCR = () => {
    setIsHandwritingVisible(true);
  };

  const handleCloseMathOCR = () => {
    setIsHandwritingVisible(false);
  };

  const languageOptions = [
    { code: "en-US", name: "English (United States)" },
    { code: "en-GB", name: "English (United Kingdom)" },
    // { code: "en-AU", name: "English (Australia)" },
    // { code: "en-CA", name: "English (Canada)" },
    // { code: "en-IN", name: "English (India)" },
    // { code: "fr-FR", name: "French (France)" },
    // { code: "fr-CA", name: "French (Canada)" },
    // { code: "es-ES", name: "Spanish (Spain)" },
    // { code: "es-MX", name: "Spanish (Mexico)" },
    // { code: "de-DE", name: "German (Germany)" },
    // { code: "it-IT", name: "Italian (Italy)" },
    // { code: "pt-BR", name: "Portuguese (Brazil)" },
    // { code: "pt-PT", name: "Portuguese (Portugal)" },
    // { code: "ru-RU", name: "Russian (Russia)" },
    // { code: "ja-JP", name: "Japanese (Japan)" },
    // { code: "zh-CN", name: "Chinese (Simplified, China)" },
    // { code: "zh-TW", name: "Chinese (Traditional, Taiwan)" },
    // { code: "ko-KR", name: "Korean (South Korea)" },
    // { code: "nl-NL", name: "Dutch (Netherlands)" },
    // { code: "sv-SE", name: "Swedish (Sweden)" },
    // { code: "no-NO", name: "Norwegian (Norway)" },
    // { code: "da-DK", name: "Danish (Denmark)" },
    // { code: "fi-FI", name: "Finnish (Finland)" },
    { code: "ar-SA", name: "Arabic (Saudi Arabia)" },
    { code: "hi-IN", name: "Hindi (India)" },
    { code: "bn-BD", name: "Bengali (Bangladesh)" },
    { code: "ta-IN", name: "Tamil (India)" },
    { code: "te-IN", name: "Telugu (India)" },
    { code: "ur-PK", name: "Urdu (Pakistan)" },
    // { code: "tr-TR", name: "Turkish (Turkey)" },
    // { code: "el-GR", name: "Greek (Greece)" },
  ];

// SpeechSynthesisVoice
// 0: {voiceURI: 'Microsoft David - English (United States)', name: 'Microsoft David - English (United States)', lang: 'en-US', localService: true, default: true}
// 1: {voiceURI: 'Microsoft Ravi - English (India)', name: 'Microsoft Ravi - English (India)', lang: 'en-IN', localService: true, default: false}
// 2: {voiceURI: 'Microsoft Heera - English (India)', name: 'Microsoft Heera - English (India)', lang: 'en-IN', localService: true, default: false}
// 3: {voiceURI: 'Microsoft Mark - English (United States)', name: 'Microsoft Mark - English (United States)', lang: 'en-US', localService: true, default: false}
// 4: {voiceURI: 'Microsoft Zira - English (United States)', name: 'Microsoft Zira - English (United States)', lang: 'en-US', localService: true, default: false}
// 5: {voiceURI: 'Microsoft Hemant - Hindi (India)', name: 'Microsoft Hemant - Hindi (India)', lang: 'hi-IN', localService: true, default: false}
// 6: {voiceURI: 'Microsoft Kalpana - Hindi (India)', name: 'Microsoft Kalpana - Hindi (India)', lang: 'hi-IN', localService: true, default: false}
// 7: {voiceURI: 'Google Deutsch', name: 'Google Deutsch', lang: 'de-DE', localService: false, default: false}
// 8: {voiceURI: 'Google US English', name: 'Google US English', lang: 'en-US', localService: false, default: false}
// 9: {voiceURI: 'Google UK English Female', name: 'Google UK English Female', lang: 'en-GB', localService: false, default: false}
// 10: {voiceURI: 'Google UK English Male', name: 'Google UK English Male', lang: 'en-GB', localService: false, default: false}
// 11: {voiceURI: 'Google español', name: 'Google español', lang: 'es-ES', localService: false, default: false}
// 12: {voiceURI: 'Google español de Estados Unidos', name: 'Google español de Estados Unidos', lang: 'es-US', localService: false, default: false}
// 13: {voiceURI: 'Google français', name: 'Google français', lang: 'fr-FR', localService: false, default: false}
// 14: {voiceURI: 'Google हिन्दी', name: 'Google हिन्दी', lang: 'hi-IN', localService: false, default: false}
// 15: {voiceURI: 'Google Bahasa Indonesia', name: 'Google Bahasa Indonesia', lang: 'id-ID', localService: false, default: false}
// 16: {voiceURI: 'Google italiano', name: 'Google italiano', lang: 'it-IT', localService: false, default: false}
// 17: {voiceURI: 'Google 日本語', name: 'Google 日本語', lang: 'ja-JP', localService: false, default: false}
// 18: {voiceURI: 'Google 한국의', name: 'Google 한국의', lang: 'ko-KR', localService: false, default: false}
// 19: {voiceURI: 'Google Nederlands', name: 'Google Nederlands', lang: 'nl-NL', localService: false, default: false}
// 20: {voiceURI: 'Google polski', name: 'Google polski', lang: 'pl-PL', localService: false, default: false}
// 21: {voiceURI: 'Google português do Brasil', name: 'Google português do Brasil', lang: 'pt-BR', localService: false, default: false}
// 22: {voiceURI: 'Google русский', name: 'Google русский', lang: 'ru-RU', localService: false, default: false}
// 23: {voiceURI: 'Google 普通话（中国大陆）', name: 'Google 普通话（中国大陆）', lang: 'zh-CN', localService: false, default: false}
// 24: {voiceURI: 'Google 粤語（香港）', name: 'Google 粤語（香港）', lang: 'zh-HK', localService: false, default: false}
// 25: {voiceURI: 'Google 國語（臺灣）', name: 'Google 國語（臺灣）', lang: 'zh-TW', localService: false, default: false}

  const [readSettings, setReadSettings] = useState({
    practiceApproach: '',
    timer: '',
    screenType: '',
    practiceMedium: '',
    baseLanguage: splTextLang,   //'en-US',
    pitch: 1.0,
    speed: 1.0,
    volume: 1.0,
    aiSpeechToText: '',
    cloudStorage: '',
    personalCloud: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setReadSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value
    }));
  };

  const handleLanguageChange = (e) => {
    const selectedCode = e.target.value;
    setSelectedLanguage(selectedCode);
  };

  useEffect(() => {
    const startTime = new Date();
    setPageLoadTime(startTime);
  }, []); 


  useEffect(() => {
    setPageLoadTime(new Date());
  }, []);

  const resetElapsedTime = () => {
    setElapsedTime(0);
  };
  useEffect(() => {
    const timer = setInterval(() => {
      setElapsedTime((prevTime) => prevTime + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // BookPage
  const fetchBookPage = useCallback(() => {
    if(bookMasterId === "nobookmasterid") {
      return;
    }
    const config = {
      url: "/readbook",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        bookMasterId,
        bookCollectionName,
        currentPageNumber,
        readerCode: authState.user.think5whyscode,
        readerName: authState.user.name
      },
    };

    fetchData(config, { showSuccessToast: false })
      .then((response) => {
        if (response && response.pageContent) {
          // console.log("Page Content ",response);
          setPageContent(response.pageContent);
          setSplText(response.splText);
          setBookTitle(response.bookTitle);
          setHasSpeech(response.hasSpeech);
          setHasMusic(response.hasMusic);
          setHasVideo(response.hasVideo);
          setVideoUrl(response.videoURL);
          setIsBase64Audio(response.isBase64Audio);
          setBase64Audio(response.base64Audio);
          if ("readFromSplText" in response) {
            setReadFromSplText(response.readFromSplText);
          } else {
            setReadFromSplText(0);
          }
          setIsPageImage(response.isPageImage ?? false);
          setPageImageURL(response.pageImageURL ?? '');
          setSplTextLang(response.splTextLang ?? 'en-US');
          setError(null);
        } else {
          console.error(
            "Invalid response format: Page data not found in response"
          );
        }
        resetElapsedTime();
        setPageLoadTime(new Date());
      })
      .catch((error) => {
        console.error("Error fetching book page:", error);
        console.error("Error fetching set masters:", error);
      });
  }, [
    authState.token,
    bookMasterId,
    bookCollectionName,
    currentPageNumber,
    fetchData,
  ]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchBookPage();
  }, [
    authState.isLoggedIn,
    fetchBookPage,
    location.state.bookMasterId,
    location.state.bookCollectionName,
    location.state.lastPageRead,
  ]);

  // Save Read Log
  const saveReadLog = async (remarks, elapsedTime, whichButton) => {
    const localDateString = new Date(dateRead - dateRead.getTimezoneOffset() * 60000).toISOString();
    try {
      const readingRemarks = isChildren === 1 ? splText : remarks;
      const response = await fetch("/api/myreadinglog", {
        method: "POST",
        headers: {
          Authorization: authState.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          bookId: bookMasterId,
          userId: userId,
          dateRead: localDateString,
          pageNumber: currentPageNumber,
          readTimeInMiliseconds: elapsedTime,
          readingRemarks: readingRemarks,
          isActive: 1,
          isDeleted: 0,
          coReaderId: userId,
          readerCode: authState.user.think5whyscode,
          readerName: authState.user.name,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to update app like");
      }

      const data = await response.json();
      setSuccessMessage(true);
      setReadTimeInMiliseconds(0);
      setPageLoadTime(new Date());
    } catch (error) {
      console.error("Error while saving read log:", error);
    }
  };

  const saveReadLogIfNeeded = () => {
    if (isInteracted && !isLogSaved) {
      setCurrentPageNumber(currentPageNumber);
      let currentTime = new Date();
      const elapsedTime = currentTime - pageLoadTime;
      setReadTimeInMiliseconds(elapsedTime);
      setReadingRemarks("Swipe");
      saveReadLog(currentPageNumber, elapsedTime, "Selected Page");
      currentTime = new Date();
      setPageLoadTime(currentTime);
      setIsLogSaved(true);
    }
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handlePageChange = (e) => {
    const selectedPage = parseInt(e.target.value);
    setCurrentPageNumber(selectedPage);
    const currentPageNumber = selectedPage;
    setReadingRemarks("Select Page Clicked");

    let currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);

    saveReadLog(currentPageNumber, elapsedTime, "Selected Page");
    currentTime = new Date();
    setPageLoadTime(currentTime);
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handleNextPage = () => {
    setReadingRemarks("Next button clicked");
    let currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);

    saveReadLog(currentPageNumber, elapsedTime, "Next Button");
    currentTime = new Date();
    setPageLoadTime(currentTime);

    if (currentPageNumber < pageCount) {
      speech.cancel();
      setIsSpeaking(false);
      setCurrentPageNumber(currentPageNumber + 1);
    }
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handlePrevPage = () => {
    setReadingRemarks("Prev button clicked");
    let currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);
    saveReadLog(currentPageNumber, elapsedTime, "Prev Button");
    currentTime = new Date();
    setPageLoadTime(currentTime);
    if (currentPageNumber > 1) {
      speech.cancel();
      setIsSpeaking(false);
      setCurrentPageNumber(currentPageNumber - 1);
    }
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handleSwipe = () => {
    setIsInteracted(true);
    setReadingRemarks("Swiped");
    saveReadLogIfNeeded();
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      handleSwipe();
      handleNextPage();
    },
    onSwipedRight: () => {
      handleSwipe();
      handlePrevPage();
    },
  });

  const handleClose = () => {
    setReadingRemarks("Close button clicked");
    const currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);
    const remarks = "Closed";
    saveReadLog(currentPageNumber, elapsedTime, "Close Button")
      .then(() => {
        window.location.href = "/bookshelf";
      })
      .catch((error) => {
        console.error("Error saving log:", error);
      });
  };

  useEffect(() => {
    setReadTimeInMiliseconds(0);
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const speech = new Speech();
  // const toggleSpeech = () => {
  //   const textToSpeak =  (readFromSplText === 1 ? splText : pageContent);
  //   console.log(textToSpeak, selectedLangCode);
  //   if (isSpeaking) {
  //     speech.cancel();
  //     setIsSpeaking(false);
  //   } else {
  //     setIsSpeaking(true);
  //     speech.setRate(1.0);
  //     speech.setPitch(2.0);
  //     speech.setVolume(1.0);
  //     speech.setLanguage(selectedLangCode);
  //     speech.speak({ text: textToSpeak });
  //     // if (readFromSplText === 1) {
  //     //   speech.speak({ text: splText });
  //     // } else {
  //     //   speech.speak({ text: pageContent });
  //     // }
  //   }
  // };

  const toggleSpeech = () => {
    const textToSpeak = readFromSplText === 1 ? splText : pageContent;
    // console.log("999: ", textToSpeak, selectedLangCode, splTextLang );
  
    if (isSpeaking) {
      speech.cancel();
      setIsSpeaking(false);
      clearInterval(emojiInterval); 
      setShowEmoji(false); 
    } else {
      setIsSpeaking(true);
  
      const voices = window.speechSynthesis.getVoices();
      const selectedVoice = voices.find(
        (voice) => voice.lang === "en-US" && voice.name === "Google US English"
      );
  
      if (selectedVoice) {
        speech.voice = selectedVoice;
      } else {
        const fallbackVoice = voices.find((voice) => voice.lang === "en-US");
        if (fallbackVoice) {
          speech.voice = fallbackVoice;
        }
      }
  
      // Set other speech parameters
      speech.setRate(1.0); // Normal speaking rate
      speech.setPitch(2.0); // Adjust pitch to your liking
      speech.setVolume(1.0); // Maximum volume
      
      speech.setLanguage(readFromSplText === 1 ? splTextLang : selectedLangCode ); // Ensure the language is still set
  
      // Start speaking the selected text
      speech.speak({ text: textToSpeak });
  
      // Show emoji overlay and start interval
      setShowEmoji(true);
      const interval = setInterval(() => {
        setCurrentEmoji((prev) => (prev === "😮" ? "😐" : "😮"));
      }, 250);
      setEmojiInterval(interval);
    }
  };

  useEffect(() => {
    return () => {
      if (isSpeaking) {
        speech.cancel();
        setIsSpeaking(false);
      }
    };
  }, [isSpeaking]);

  // React state to manage emoji and overlay
  const [currentEmoji, setCurrentEmoji] = useState("😐");
  const [showEmoji, setShowEmoji] = useState(false);
  const [emojiInterval, setEmojiInterval] = useState(null);

  useEffect(() => {
    return () => {
      if (emojiInterval) clearInterval(emojiInterval);
    };
  }, [emojiInterval]);


  const [isNotesSpeaking, setIsNotesSpeaking] = useState(false);
  const toggleSpeechNotes = (mynotestext) => {
    // console.log("my notes text ",mynotestext);

    if (isNotesSpeaking) {
      speech.cancel();
      setIsNotesSpeaking(false);
    } else {
      setIsNotesSpeaking(true);
      speech.setRate(1.0);
      speech.setPitch(2.0);
      speech.setVolume(1.0);
      speech.setLanguage(selectedLangCode);
      speech.speak({ text: mynotestext });
    }
  };

  useEffect(() => {
    return () => {
      if (isNotesSpeaking) {
        speech.cancel();
        setIsNotesSpeaking(false);
      }
    };
  }, [isNotesSpeaking]);


  const toggleMusic = () => {
    if (isListening) {
      musicAudio.pause();
    } else {
      musicAudio.play();
    }

    setIsListening(!isListening);
  };

  musicAudio.addEventListener("ended", () => {
    if (isListening) {
      musicAudio.currentTime = 0;
      musicAudio.play();
    }
  });

  const watchVideo = () => {
    // console.log("Video URL Check ",hasVideo, videoUrl);
    if (videoUrl) {
      window.open(videoUrl, "_blank");
    }
  };

  const accessSite = (siteUrl) => {
    if (siteUrl) {
      const formattedUrl = siteUrl.startsWith("http://") || siteUrl.startsWith("https://")
        ? siteUrl
        : `http://${siteUrl}`;
      window.open(formattedUrl, "_blank");
    } else {
      console.error("URL is not provided.");
    }
  };
  

  const listenVoice = () => {
    if (base64Audio) {
      const audio = new Audio(`data:audio/mpeg;base64,${base64Audio}`);
      audio.play();
    }
  };

  const handleIsAudioNotesChange = (event) => {
    setIsAudioNotes(event.target.checked);
  };

  const handleMoreInputsCheckboxChange = (event) => {
    setIsMoreInputs(event.target.checked);
  };

  const handleImportantCheckboxChange = (event) => {
    setIsImportantChecked(event.target.checked);
  };
  
  const handleVisibleToAllCheckboxChange = (event) => {
    setIsVisibleToAllChecked(event.target.checked);
  };

  const handleConversationalNotesCheckboxChange = (event) => {
    setIsCoversationalNotes(event.target.checked);
  };

  const handleShowMicrophoneAlertCheckboxChange = (event) => {
    setShowMicrophoneAlert(event.target.checked);
  };

  const [downloadPDFClicked, setDownloadPDFClicked] = useState(false);
  const handleDownloadPDF = () => {
    setDownloadPDFClicked(!downloadPDFClicked);
  };

  const postComment = () => {
    setNotesType('');
    setUserCommentTitle('');
    setUserCommentDetails('');
    setIsAudioNotes(false);
    setIsImportantChecked(false);
    setIsVisibleToAllChecked(false);
    setErrors('');
    setPostedCommentMsg('');    
    setPostCommentClicked(true);
    setPostCloseClicked(false);
    setPostToBeDisabled(false);
    setViewComment(false);
    setPostedComment(false);
    setIsEditCommentClicked(false);
  };

  const handlePostComment = (
    commentTitle, 
    commentDetails, 
    notesType, 
    isImportant, 
    visibleToAll, 
    pageNumber, 
    bookTitle, 
    notesRemarks,
    sortTags,
    isMoreInputs,
    subjectName,
    bookName,
    chapter,
    chapterSection,
    chapterSubSection,
    bookPageNumber,
    institution,
    teacherName,
    studyClass,
    sectionName,
    studySession,
    isSelfstudyChecked) => {
    setPostCommentClicked(true);
    setPostToBeDisabled(false);

    // console.log('inside handlePostComment', pageNumber );
    if(notesType=='')
      {
        setErrors("Select Comment/Notes Type");
        return;
      }
    if(commentTitle=='')
      {
        setErrors("Comment title must not be blank");
        return;
      }
      if(commentDetails=='')
        {
          setErrors("Comment/details must not be blank");
          return;
        }
    postReadComment(
      commentTitle, 
      commentDetails, 
      notesType, 
      isImportant, 
      visibleToAll, 
      pageNumber, 
      bookTitle,
      notesRemarks,
      sortTags,
      isMoreInputs,
      subjectName,
      bookName,
      chapter,
      chapterSection,
      chapterSubSection,
      bookPageNumber,
      institution,
      teacherName,
      studyClass,
      sectionName,
      studySession,
      isSelfstudyChecked);
  };


//Read Post Comments 
const postReadComment = useCallback((
  commentTitle, 
  commentDetails, 
  notesType, 
  isImportant, 
  visibleToAll, 
  pageNumber, 
  bookTitle,
  notesRemarks,
  sortTags,
  isMoreInputs,
  subjectName,
  bookName,
  chapter,
  chapterSection,
  chapterSubSection,
  bookPageNumber,
  institution,
  teacherName,
  studyClass,
  sectionName,
  studySession,
  isSelfstudyChecked) => {
    const config = {
      url: "/myreadingnotes",
      method: "post",
      headers: { Authorization: authState.token },
      data: { 
        userId: userId,
        bookId: bookMasterId, 
        bookTitle: bookTitle,
        pageNumber: pageNumber,
        isImportant: isImportant,
        notesType: notesType,
        notesTitle: commentTitle,
        notesText: commentDetails, 
        notesBy: authState.user.name, 
        notesByCode: authState.user.think5whyscode,
        visibleToAll: visibleToAll,
        teamCode: '',
        notesPictureData: '',
        isActive: true,
        isDeleted: false,
        dateCreated: new Date(),
        creatorId:authState.user._id,
   
        notesRemarks: notesRemarks,
        sortTags: sortTags,
        isMoreInputs: isMoreInputs,
        subjectName: subjectName,
        bookName: bookName,
        chapter: chapter,
        chapterSection: chapterSection,
        chapterSubSection: chapterSubSection,
        bookPageNumber: bookPageNumber,
        institution: institution,
        teacherName: teacherName,
        studyClass: studyClass,
        sectionName: sectionName,
        studySession: studySession,
        isSelfstudyChecked: isSelfstudyChecked,
      }
    };
    // console.log("BookRead Post Comments config to server: ", config);
  
    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("BookRead comments data posting Response:", response);
        if (response && response.status) {
          setPostedComment(true);
          setPostedCommentMsg("Comment Posted");
          setError('');
        } else {
          console.error("BookRead comments data posting error");
          setPostedCommentMsg("Error in Posting Your Comment. Please Retry.");
        }
      })
      .catch(error => {
        console.error("Error in Posting Your Comment:", error);
      });
  }, [authState.token, setPostedComment, setPostedCommentMsg]);


  const readComment = () => {
    setReadCommentClicked(true);
    // fetchReadCommentByPageNumber();
  };

  //Read Comments List
  const fetchReadCommentByPageNumber = useCallback(() => {
    const config = {
      url: "/myreadingnotes/notesbybookpage",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        bookId: bookMasterId, 
        userId: userId, 
        pageNumber: currentPageNumber
      }
    };
    // console.log("Read Comments config to server: ", config);
    
    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("Read Comments Response:", response);
        if (response && response.status) {
          setCommentData(response.notes);
          // console.log("setCommentData ", response.notes); // Log response.notes
        } else {
          console.error("Read Comments data not found in response");
        }
      })
      .catch(error => {
        console.error("Error fetching Read Comments data:", error);
      });
  }, [authState.token, fetchData, bookMasterId, userId, currentPageNumber]);


  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchReadCommentByPageNumber();
  }, [authState.isLoggedIn, fetchReadCommentByPageNumber]);

  const sortedCommentData = [...commentData ].sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));

  const handlePostClose = () => {
    setPostCloseClicked(true);
    setPostCommentClicked(true);
    setPostToBeDisabled(true);
    setAddNewLink(false);
    setReadCommentClicked(false);
    setViewComment(false);
    setPostedComment(false);
  };

  const [viewComment, setViewComment] = useState(false);
  const handleViewComment = () => {
    setViewComment(true);
    setPostCommentClicked(false);
    setIsEditCommentClicked(false);
    fetchReadCommentByPageNumber();
  }

  const handleReadCommentClose = () => {
    setReadCommentClicked(false);
    setReadCommentCloseClicked(true);
  };

  const handleListLinkButtonClick = () => {
    setListLink(true);
    setAddNewLink(false);
    fetchListLinkByPageNumber();
  };

  const handleAddNewLinkButtonClick = () => {
    setAddNewLink(true);
    setListLink(false);
  };

  const handleCloseLinkButtonClick = () => {
    setBookLinkClicked(false);
  };

  const handleListLinkCloseButtonClick = () => {
    setListLink(false);
  };
  
  const bookLinks = () => {
    setErrors('');
    setSavedBookLinkMsg('');    
    setBookLinkClicked(true);
    setBookLinkCloseClicked(false);
    setBookLinkToBeDisabled(false);
    setSaveBookLinkClicked(false);
    setSaveBookLinkToBeDisabled(false);
    setAddNewLink(false);
    setListLink(false);
  };



  const settings = () => {
    setSettingsClicked(true);
  };

  const handleSettingsClose = () => {
    setSettingsClicked(false);
    // setSettingsClosed(true);
  };


  const [listLinkData, setListLinkData] = useState([]);
  //Get List Link
  const fetchListLinkByPageNumber = useCallback(() => {
    const config = {
      url: "/myreadingnotesurls/linksbybookpage",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        bookId: bookMasterId, 
        userId: userId, 
        pageNumber: currentPageNumber
      }
    };
    // console.log("List Link config to server: ", config);
    
    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("List Link Response:", response);
        if (response && response.status) {
          setListLinkData(response.urls);
          // console.log("setListLinkData ", response.urls); // Log response.notes
        } else {
          console.error("List Link data not found in response");
        }
      })
      .catch(error => {
        console.error("Error fetching List Link data:", error);
      });
  }, [authState.token, fetchData, bookMasterId, userId, currentPageNumber]);


  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchListLinkByPageNumber();
  }, [authState.isLoggedIn, fetchListLinkByPageNumber]);

  const sortedListLinkData = [...listLinkData ].sort((a, b) => b.linkName - a.linkName);

  const handleIsVideoCheckboxChange = (event) => {
    setIsVideoChecked(event.target.checked);
  };

                     
  const handleSaveBookLink = (linkName, linkPageName, linkTitle, linkAddress, isVideoChecked, linkDetails, linkPageNumber) => {
    setSaveBookLinkClicked(true);
    setSaveBookLinkToBeDisabled(false);

    // console.log('inside hahandleSaveBookLink', pageNumber );
    if(linkName=='')
      {
        setErrors("Link name required!");
        return;
      }
      if(linkPageName=='')
        {
          setErrors("Page/Channel name required!");
          return;
      }
      if(linkAddress=='')
        {
          setErrors("Link URL/address is required!");
          return;
        }
      if(linkTitle=='')
        {
          setErrors("Title required!");
          return;
        }
    saveBookLink(linkName, linkPageName, linkTitle, linkAddress, isVideoChecked, linkDetails, linkPageNumber);
  };

const saveBookLink = useCallback((linkName, linkPageName, linkTitle, linkAddress, isVideoChecked, linkDetails, linkPageNumber) => {
    const config = {
      url: "/myreadingnotesurls",
      method: "post",
      headers: { Authorization: authState.token },
      data: { 
        userId: userId,
        bookId: bookMasterId, 
        bookTitle: bookTitle,
        pageNumber: linkPageNumber,
        notesType: notesType,
        linkName: linkName,
        linkPageName: linkPageName, 
        linkTitle: linkTitle, 
        linkAddress: linkAddress,
        isVideoChecked: isVideoChecked,
        linkDetails: linkDetails,
        isActive: true,
        isDeleted: false,
        dateCreated: new Date(), 
        creatorId:authState.user._id
      }
    };
    // console.log("BookRead Book Link config to server: ", config);
  
    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("BookRead Book Link  data posting Response:", response);
        if (response && response.status) {
          setBookLinkSaved(true);
          setBookLinkSavedMsg("BookLink Saved.");
          setAddNewLink(false);
          setListLink(false);
          setLinkAddress('');
          setIsVideoChecked(false);
          setLinkTitle('');
        } else {
          console.error("Booklink data posting error");
          setBookLinkSavedMsg("Error in Posting Your BookLink. Please Retry.");
        }
      })
      .catch(error => {
        console.error("Error in Posting Your Booklink:", error);
      });
  }, [authState.token, setBookLinkSaved, setBookLinkSavedMsg]);


  const formatDateTime = (date) => {
    const options = {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const handleSaveSettings = () => {
    // console.log('inside handleSaveSettings' );
    
    const saveSettings = '';
    setSettingsClicked(false);

  };

  const handleContinuousAutoPageReadChange = (event) => {
    setIsContinuousAutoPageReadChecked(event.target.checked);
    if (!event.target.checked) {
      setFromPageNumber(1);
      setToPageNumber(1);
    }
  };

  const handleFromPageNumberChange = (event) => {
    const value = Math.min(Math.max(1, parseInt(event.target.value)), numberOfPages);
    setFromPageNumber(value);
    if (value > toPageNumber) {
      setToPageNumber(Math.min(value + 4, numberOfPages));
    }
  };
  
  const handleToPageNumberChange = (event) => {
    const value = Math.min(Math.max(fromPageNumber, parseInt(event.target.value)), fromPageNumber + 4, numberOfPages);
    setToPageNumber(value);
  };

  const [isListenNotesClicked, setIsListenNotesClicked] = useState(false);
  
  const listenNotesClicked = (mynotestext) => {
    setIsListenNotesClicked(true);
    speech.cancel();
    toggleSpeechNotes(mynotestext);
  }

  const editCommentClicked = (notesId) => {
    setIsEditCommentClicked(true);
    setSelectedCommentId(notesId);
    setPostCommentClicked(false);
    fetchNotesById(notesId);
  }

  const fetchNotesById = useCallback((notesId) => {
    const config = {
        url: "/myreadingnotes/getnotesbyid",
        method: "post",
        headers: { Authorization: authState.token },
        data: { notesId: notesId }
    };
    // console.log("Getting notesId: ",config);
  
    fetchData(config, { showSuccessToast: false })
        .then(response => {
            // console.log("Response:", response);
            if (response) {
              setNotesType(response.notesType);
              setUserCommentTitle(response.notesTitle);
              setUserCommentDetails(response.notesText);
              setIsImportantChecked(response.isImportant);            
              setIsVisibleToAllChecked(response.visibleToAll);
              setNotesRemarks(response.notesRemarks);
              setSortTags(response.sortTags);
              setSubjectName(response.subjectName);
              setBookName(response.bookName);
              setChapter(response.chapter);
              setChapterSection(response.chapterSection);
              setChapterSubSection(response.chapterSubSection);
              setBookPageNumber(response.bookPageNumber);
              setInstitution(response.institution);
              setTeacherName(response.teacherName);
              setStudyClass(response.studyClass);
              setSectionName(response.sectionName);
              setStudySession(response.studySession);
              setIsSelfstudyChecked(response.isSelfstudyChecked);
            } else {
                console.error("Invalid response format!");
            }
        })
        .catch(error => {
            console.error("Error fetching the Note:", error);
        });
  }, [authState.token, fetchData]);
  
  //  useEffect(() => {
  //     if (!authState.isLoggedIn) return;
  //     fetchNotesById();
  //   }, [authState.isLoggedIn, fetchNotesById]);

    useEffect(() => {
      if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn]);

    const handleEditComment = (
      selectedCommentId,
      commentTitle, 
      commentDetails, 
      notesType, 
      isImportant, 
      visibleToAll, 
      pageNumber, 
      bookTitle, 
      notesRemarks,
      sortTags,
      isMoreInputs,
      subjectName,
      bookName,
      chapter,
      chapterSection,
      chapterSubSection,
      bookPageNumber,
      institution,
      teacherName,
      studyClass,
      sectionName,
      studySession,
      isSelfstudyChecked) => {
      setPostCommentClicked(true);
      setPostToBeDisabled(false);
  
      // console.log('inside handlePostComment', pageNumber );
      if(notesType=='')
        {
          setErrors("Select Comment/Notes Type");
          return;
        }
      if(commentTitle=='')
        {
          setErrors("Comment title must not be blank");
          return;
        }
        if(commentDetails=='')
          {
            setErrors("Comment/details must not be blank");
            return;
          }
      postEditComment(
        selectedCommentId,
        commentTitle, 
        commentDetails, 
        notesType, 
        isImportant, 
        visibleToAll, 
        pageNumber, 
        bookTitle,
        notesRemarks,
        sortTags,
        isMoreInputs,
        subjectName,
        bookName,
        chapter,
        chapterSection,
        chapterSubSection,
        bookPageNumber,
        institution,
        teacherName,
        studyClass,
        sectionName,
        studySession,
        isSelfstudyChecked);
    };

//Edit Post Comments 
const postEditComment = useCallback((
  selectedCommentId,
  commentTitle, 
  commentDetails, 
  notesType, 
  isImportant, 
  visibleToAll, 
  pageNumber, 
  bookTitle,
  notesRemarks,
  sortTags,
  isMoreInputs,
  subjectName,
  bookName,
  chapter,
  chapterSection,
  chapterSubSection,
  bookPageNumber,
  institution,
  teacherName,
  studyClass,
  sectionName,
  studySession,
  isSelfstudyChecked) => {
    const config = {
      url: "/myreadingnotes/updatebynotesid",
      method: "post",
      headers: { Authorization: authState.token },
      data: { 
        notesId: selectedCommentId,
        userId: userId,
        bookId: bookMasterId, 
        bookTitle: bookTitle,
        pageNumber: pageNumber,
        isImportant: isImportant,
        notesType: notesType,
        notesTitle: commentTitle,
        notesText: commentDetails, 
        notesBy: authState.user.name, 
        notesByCode: authState.user.think5whyscode,
        visibleToAll: visibleToAll,
        teamCode: '',
        notesPictureData: '',
        isActive: true,
        isDeleted: false,
        dateCreated: new Date(),
        creatorId:authState.user._id,
   
        notesRemarks: notesRemarks,
        sortTags: sortTags,
        isMoreInputs: isMoreInputs,
        subjectName: subjectName,
        bookName: bookName,
        chapter: chapter,
        chapterSection: chapterSection,
        chapterSubSection: chapterSubSection,
        bookPageNumber: bookPageNumber,
        institution: institution,
        teacherName: teacherName,
        studyClass: studyClass,
        sectionName: sectionName,
        studySession: studySession,
        isSelfstudyChecked: isSelfstudyChecked,
      }
    };
    // console.log("BookRead Post Comments config to server: ", config);
  
    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("BookRead comments data posting Response:", response);
        if (response && response.status) {
          setPostedComment(true);
          setPostedCommentMsg("Edited Comment Posted");
          setError('');
        } else {
          console.error("Notes Edit data posting error");
          setPostedCommentMsg("Error in Posting Your Edited Comment Record. Please Retry.");
        }
      })
      .catch(error => {
        console.error("Error in Posting Your Edited Comment:", error);
      });
  }, [authState.token, setPostedComment, setPostedCommentMsg]);


  const [isDeleteCommentClicked, setIsDeleteCommentClicked] = useState(false);
  const [selectedCommentId, setSelectedCommentId] = useState(null);
  const deleteCommentClicked = (commentId) => {
    setSelectedCommentId(commentId);
    setIsEditCommentClicked(false);
    setPostCommentClicked(false);
    setIsDeleteCommentClicked(true);
  }
  
  const noDeleteCommentClicked = () => {
    setIsDeleteCommentClicked(false);
  }

  const handleDeleteComment = (id) => {
    // console.log("For Delete: ",id);
    const config = {
      url: `/myreadingnotes/${id}`,
      method: "delete",
      headers: { Authorization: authState.token }
    };
    fetchData(config).then(() => {
      setCommentData(commentData.filter(commentData => commentData._id !== id));
      setIsDeleteCommentClicked(false);
    }).catch(error => {
      console.error('Failed to delete the record:', error);
    });
  }

  const [isDeleteLinkClicked, setIsDeleteLinkClicked] = useState(false);
  
  const deleteLinkClicked = () => {
    setIsDeleteLinkClicked(true);
  }
  
  const noDeleteLinkClicked = () => {
    setIsDeleteLinkClicked(false);
  }

  const handleDeleteLink = (id) => {
    const config = {
      url: `/myreadingnotesurls/${id}`,
      method: "delete",
      headers: { Authorization: authState.token }
    };
    fetchData(config).then(() => {
      setListLinkData(listLinkData.filter(listLinkData => listLinkData._id !== id));
      setIsDeleteLinkClicked(false);
    }).catch(error => {
      console.error('Failed to delete the record:', error);
    });
  }

  const handleImageClick = () => {
    setIsOverlayOpen(true);
};

const handleCloseOverlay = () => {
    setIsOverlayOpen(false);
};

const [filterBy, setFilterBy] = useState("All Notes");

const filteredComments = useMemo(() => {
  return filterBy === "All Notes"
    ? sortedCommentData
    : sortedCommentData.filter((comment) => comment.notesType === filterBy);
}, [sortedCommentData, filterBy]);

  return (
      <div
        className="readbook-container my-2 mx-auto py-4 bg-white text-black fixed-height-container"
        style={{ height: "100vh", overflow: "auto" }}
        {...swipeHandlers}
      >
        {loading ? (
          <div className="spinner-container">
            <div className="spinner">
              <FontAwesomeIcon icon={faSpinner} spin />
            </div>
          </div>
        ) : (
          <>
            <div
              className="fixed-height-container mt-2 mb-2"
              style={{
                flex: 1,
                overflowY: "auto",
                maxWidth: "100%",
                maxHeight: "100vh",
              }}
            >
              <div className="flex justify-between items-center mt-2 mb-2 bg-cyan-900 text-white mr-1 ml-1">
                <div
                  className="text-wrap"
                  style={{ width: "100%", maxHeight: "80px", overflow: "hidden" }}
                >
                  <h3 className="mt-1 mx-2 max-w-[750px] bg-cyan-900 text-white book-title ">
                    <i
                      className="fa fa-book-open text-white"
                      aria-hidden="true"
                    ></i>
                    <span className="text-white ml-2 text-wrap">{bookTitle ? bookTitle : "Undefined Book"}</span>                  
                  </h3>
                  <h3 className="book-timer ml-2">{elapsedTime} seconds </h3>
                </div>
                <div
                  style={{ width: "10%", maxHeight: "40px", overflow: "hidden" }}
                >
                  <button className="mx-1  bg-cyan-900" onClick={handleClose}>
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="ml-1 mr-1 flex justify-between bg-black">
                <button
                  className="ml-1 mt-2 max-w-8 px-2 py-2 bg-orange-600 text-white"
                  onClick={toggleSpeech}
                  disabled={hasSpeech === 0}
                >
                  {isSpeaking ? (
                    <FontAwesomeIcon icon={faStop} />
                  ) : (
                    <FontAwesomeIcon icon={faPlay} />
                  )}
                </button>
                {showEmoji && (
                  <button
                    onClick={() => setShowEmoji(false)}  
                    className="ml-1 mt-2 max-w-8 px-2 py-2 bg-transparent text-white" 
                  >
                    <span className="text-3xl">
                      {currentEmoji}  
                    </span>
                  </button>
                )}
                {(hasMusic && isChildren === 1 ) && (
                  <button
                    className="ml-1 mt-2 max-w-8 px-2 py-2 bg-green-800 text-white"
                    onClick={toggleMusic}
                    disabled={hasMusic === 0}
                  >
                    {isListening ? (
                      <FontAwesomeIcon icon={faMusic} />
                    ) : (
                      <FontAwesomeIcon icon={faMusic} />
                    )}
                  </button>
                )}
                { base64Audio && (
                <button
                  className="ml-1 mt-2 max-w-8 px-2 py-2 bg-blue-800 text-white"
                  onClick={listenVoice}
                  disabled={!base64Audio}
                >
                  <FontAwesomeIcon icon={faVolumeUp} />
                </button>
                )}
                { isChildren === 1 && (
                <button
                  className="ml-1 mt-2 max-w-8 px-2 py-2"
                  onClick={watchVideo}
                  disabled={hasVideo === 0}
                >
                  <FontAwesomeIcon icon={faPlayCircle} />
                </button>
                )}
                { isChildren === 0 && (
                <button
                  className="ml-1 mt-2 max-w-8 px-2 py-2 bg-purple-800 text-white"
                  onClick={readComment}
                >
                  <FontAwesomeIcon icon={faCommenting} />
                </button>
                )}
                <button
                  className="ml-1 mt-2 max-w-8 px-2 py-2 bg-purple-800 text-white"
                  onClick={bookLinks}
                >
                  <FontAwesomeIcon icon={faLink} />
                </button>
                <button
                  className="ml-1 mt-2 max-w-8 px-2 py-2"
                  onClick={settings}
                >
                  <FontAwesomeIcon icon={faGears} />
                </button>
                <button
                  title="Prev"
                  className="ml-1 mt-2 max-w-8 px-2 py-2 bg-cyan-800 text-white"
                  onClick={handlePrevPage}
                  disabled={currentPageNumber === 1}
                >
                  <i className="fa fa-angle-left" aria-hidden="true"></i>
                </button>
                <select
                  className="ml-1 mt-4 max-w-15 bg-cyan-800 text-white border-2 border-cyan-900"
                  value={currentPageNumber}
                  onChange={handlePageChange} 
                >
                  {[...Array(pageCount).keys()].map((page) => (
                    <option
                      className="text-white"
                      key={page + 1}
                      value={page + 1}
                    >
                      {page + 1}
                    </option>
                  ))}
                </select>
                <button
                  title="Next"
                  className="ml-1 mr-1 mt-2 max-w-8 px-2 py-2 bg-cyan-800 text-white"
                  onClick={handleNextPage}
                  disabled={currentPageNumber === pageCount}
                >
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
                </button>
              </div>
              { isPageImage && (
                <div>
                  {/* Thumbnail or regular image */}
                  <div className="mb-4">
                      <button
                          className="rounded-md cursor-pointer"
                          onClick={handleImageClick}
                      >
                      View Graphics
                      </button>
                  </div>

                  {/* Full Page Overlay */}
                  {isOverlayOpen && (
                      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
                        <div className="relative max-w-full max-h-full overflow-auto p-4">
                          {/* Close button at the top-right */}
                          <button
                            className="absolute top-4 right-4 text-white text-2xl bg-red-600 rounded-full p-2"
                            onClick={handleCloseOverlay}
                          >
                            &times;
                          </button>
                      
                          {/* Image displayed below the close button with margin */}
                          <img
                            src={`/api/bookpagedownloads/${pageImageURL}`}
                            alt={"No Image for Page Number " + currentPageNumber}
                            className="w-auto h-auto max-w-full max-h-screen object-contain mt-16"
                          />
                      
                          {/* Close button at the bottom */}
                          <div className="flex justify-center mt-4">
                            <button
                              className="text-white text-2xl bg-red-600 rounded-full p-2"
                              onClick={handleCloseOverlay}
                            >
                              Close &times;
                            </button>
                          </div>
                        </div>
                      </div>
                  )}
              </div>
              )}
              <div
                className="ml-2 mr-2 px-4 py-4 flex flex-col items-start bg-white text-black"
                style={{ minHeight: "100%", position: 'relative', top: 0, left: 0, right: 0 }}
                dangerouslySetInnerHTML={{ __html: pageContent }}
                {...swipeHandlers}
              />
              {/* <div
                className="ml-2 mr-2 flex flex-col items-start bg-gray-600"
                style={{ minHeight: "100%", position: 'relative', top: 0, left: 0, right: 0 }}
                {...swipeHandlers}
              >
                <div className="text-red-500" dangerouslySetInnerHTML={{ __html: pageContent }} />
              </div> */}
            </div>
            {settingsClicked && (
              <>
                <div
                  className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center"
                  style={{ zIndex: 1000 }}
                >
                  <div className="w-full max-h-full overflow-y-auto bg-blue-200 text-black border-b border-b-gray-300 p-4 rounded-md">
                    <div>
                      <h1 className="text-xl flex justify-center text-white bg-green-500">Think5Whys Read Book Preferences</h1>
                    </div>
                    {/* Checkbox Group */}
                    <div className="flex flex-col checkbox-group mb-4">
                      <label className="flex items-center mb-2 text-black">
                        <input type="checkbox" className="mr-4" />
                        Show Playback Icon
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="checkbox" className="mr-4" />
                        Show View Notes / Comments Icon
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="checkbox" className="mr-4" />
                        Show Add Comment Icons
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="checkbox" className="mr-4" />
                        Show Notes External Link Icon
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="checkbox" className="mr-4" />
                        Enable Flyers On The Wall Can Comment
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="checkbox" className="mr-4" />
                        Show Play Default Video Icon
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="checkbox" className="mr-4" />
                        Show Background Music Icon
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="checkbox" className="mr-4" />
                        Show Previous Button
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="checkbox" className="mr-4" />
                        Show Next Button
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="checkbox" className="mr-4" />
                        Show Page Selection Dropdown
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="checkbox" className="mr-4" />
                        Show Image Uploads In Add Notes
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="checkbox" className="mr-4" />
                        Show Video Uploads In Add Notes
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="checkbox" className="mr-4" />
                        Enable Personal Notes TTS
                      </label>
                      <label className="flex items-center mb-2 text-black">
                      <input
                        type="checkbox"
                        className="mr-4"
                        checked={isContinuousAutoPageReadChecked}
                        onChange={handleContinuousAutoPageReadChange}
                      />
                      Enable Continuous Auto Page Read
                      </label>
                      {isContinuousAutoPageReadChecked && (
                        <div className="mt-2 ml-6 text-black flex flex-col">
                          <label className="mr-2 text-black">From Page Number:</label>
                          <input
                            type="number"
                            min="1"
                            max={numberOfPages}
                            value={fromPageNumber}
                            onChange={handleFromPageNumberChange}
                            className="border rounded p-1 w-16 mr-4"
                          />
                          <label className="mr-2 text-black">To Page Number:</label>
                          <input
                            type="number"
                            min="1"
                            max={numberOfPages}
                            value={toPageNumber}
                            onChange={handleToPageNumberChange}
                            className="border rounded p-1 w-16"
                          />
                          <p className="text-xs text-red-600 mt-1">
                            (Max 5 pages at a time)
                          </p>
                        </div>
                      )}
                    </div>
                    <div>
                      <div className="settings-section mt-4">
                        <label className="flex items-center">
                          <input
                            type="checkbox"
                            checked={isHandWrittenTextInputEnabled}
                            onChange={(e) => setIsHandWrittenTextInputEnabled(e.target.checked)}
                            className="mr-4"
                          />
                          Enable Handwritten (Mouse on Laptop/Desktop, Stylus, Using Finger on Touchscreen Devices)
                        </label>
                      </div>

                      {/* <div className="settings-section mt-4">
                        <label className="flex items-center">
                          <input
                            type="checkbox"
                            checked={isHandWrittenFormulaInputEnabled}
                            onChange={(e) => setIsHandWrittenFormulaInputEnabled(e.target.checked)}
                            className="mr-4"
                          />
                          Enable Touchscreen Handwritten Formula Input
                        </label>
                      </div> */}
                    </div>

                    {/* Radio Button Group - Page Content TTS & Default Content TTS */}
                    <div className="radio-group mb-4 flex flex-row">
                      <label className="flex items-center mb-2 text-black">
                        <input type="radio" name="contentTTS" value="Page Content TTS" className="mr-4" />
                        Page Content TTS
                      </label>
                      <label className="ml-8 flex items-center mb-2 text-black">
                        <input type="radio" name="contentTTS" value="Default Content TTS" className="mr-4" />
                        Default Content TTS
                      </label>
                    </div>
                    
                    {/* Radio Button Group - Default Transcription (Complementary) & AI Transcription (Incurs Additional Cost) */}
                    <div className="radio-group mb-4 flex flex-row">
                      <label className="flex items-center mb-2 text-black">
                        <input type="radio" name="sttDefault" value="Default Voice Input" className="mr-4" />
                        Default Voice Input (Complementary)
                      </label>
                      <label className="ml-8 flex items-center mb-2 text-black">
                        <input type="radio" name="sttDefault" value="AI Voice Input" className="mr-4" />
                        AI Voice Input (Incurs Additional Cost)
                      </label>
                    </div>

                    {/* Select Output Language */}
                    <select
                      className="mt-4 w-full"
                      onChange={handleLanguageChange}
                      style={{
                        padding: "5px",
                        marginRight: "5px",
                        border: "1px solid #ccc",
                      }}
                    >
                      <option value="">Select Output Language</option>
                      {languageOptions.map((lang) => (
                        <option key={lang.code} value={lang.code}>
                          {lang.name}
                        </option>
                      ))}
                    </select>

                    {/* Sliders */}
                    <div className="slider-container mt-4">
                      <div className="slider-item mb-4">
                        <p>Speech Rate: {rate.toFixed(1)}</p>
                        <input
                          type="range"
                          min="0"
                          max="2"
                          step="0.1"
                          value={rate}
                          onChange={handleRateChange}
                          className="slider"
                        />
                      </div>
                      <div className="slider-item mb-4">
                        <p>Speech Volume: {volume.toFixed(1)}</p>
                        <input
                          type="range"
                          min="0"
                          max="1"
                          step="0.1"
                          value={volume}
                          onChange={handleVolumeChange}
                          className="slider"
                        />
                      </div>
                      <div className="slider-item mb-4">
                        <p>Speech Pitch: {pitch.toFixed(1)}</p>
                        <input
                          type="range"
                          min="0"
                          max="2"
                          step="0.1"
                          value={pitch}
                          onChange={handlePitchChange}
                          className="slider"
                        />
                      </div>
                    </div>

                    {/* AI Speech to Text */}
                    <div className="settings-section mt-4">
                      <h3 className="text-blue-800">AI Text To Speech</h3>
                      <div className="mt-2 flex flex-col">
                        <label htmlFor="amazonPolly" className="ml-2">
                          <input type="radio" id="amazonPolly" name="aiSpeechToText" value="Amazon Polly" onChange={handleChange} className="ml-4" />
                          Amazon Transcribe
                        </label>
                        <label htmlFor="ibmWatson" className="ml-2">
                          <input type="radio" id="ibmWatson" name="aiSpeechToText" value="IBM Watson" onChange={handleChange} className="ml-4" />
                          IBM Watson
                        </label>
                        <label htmlFor="google" className="ml-2">
                          <input type="radio" id="google" name="aiSpeechToText" value="Google" onChange={handleChange} className="ml-4" />
                          Google
                        </label>

                        <label htmlFor="google" className="ml-2">
                          <input type="radio" id="microsoft" name="aiSpeechToText" value="microsoft" onChange={handleChange} className="ml-4" />
                          Microsoft
                        </label>      

                        <label htmlFor="google" className="ml-2">
                          <input type="radio" id="deepgram" name="aiSpeechToText" value="deepgram" onChange={handleChange} className="ml-4" />
                          Deepgram
                        </label> 

                        <label htmlFor="google" className="ml-2">
                          <input type="radio" id="revAI" name="aiSpeechToText" value="revAI" onChange={handleChange} className="ml-4" />
                          Rev.ai
                        </label>

                        <label htmlFor="google" className="ml-2">
                          <input type="radio" id="speechmatics" name="aiSpeechToText" value="speechmatics" onChange={handleChange} className="ml-4" />
                          Speechmatics
                        </label>      

                        <label htmlFor="google" className="ml-2">
                          <input type="radio" id="assemblyAI" name="aiSpeechToText" value="assemblyAI" onChange={handleChange} className="ml-4" />
                          AssemblyAI
                        </label>                       

                      </div>
                    </div>

                    <div className="settings-section mt-4 flex flex-col">
                      <h3>Neural Voice Profile Preference</h3>
                      <select
                        className="mt-2 p-2 border border-gray-300 rounded-md h-10"
                        value={selectedNeuralVoice}
                        onChange={(e) => setSelectedNeuralVoice(e.target.value)}
                      >
                        <option value="">Select Neural Voice</option>
                        <option value="neural-male">Neural Male</option>
                        <option value="neural-female">Neural Female</option>
                        <option value="neural-child">Neural Child</option>
                      </select>
                    {/* </div>

                    <div className="settings-section mt-4"> */}
                      <h3>Standard Voice Profile Preference</h3>
                      <select
                        className="mt-2 p-2 border border-gray-300 rounded-md h-10"
                        value={selectedStandardVoice}
                        onChange={(e) => setSelectedStandardVoice(e.target.value)}
                      >
                        <option value="">Select Standard Voice</option>
                        <option value="tandard-male">Standard Male</option>
                        <option value="standard-female">Standard Female</option>
                      </select>
                    {/* </div>

                    <div className="settings-section mt-4"> */}
                      <h3>Expressive Voice Profile Preference</h3>
                      <select
                        className="mt-2 p-2 border border-gray-300 rounded-md h-10"
                        value={selectedExpressiveVoice}
                        onChange={(e) => setSelectedExpressiveVoice(e.target.value)}
                      >
                        <option value="">Select Expressive Voice</option>
                        <option value="joyful">Joyful</option>
                        <option value="sad">Sad</option>
                      </select>
                    {/* </div>

                    <div className="settings-section mt-4"> */}
                      <h3>Regional Accent Preference</h3>
                      <select
                        className="mt-2 p-2 border border-gray-300 rounded-md h-10"
                        value={selectedAccent}
                        onChange={(e) => setSelectedAccent(e.target.value)}
                      >
                        <option value="">Select Regional Accent</option>
                        <option value="uk-male">British Male</option>
                        <option value="uk-female">British Female</option>
                        <option value="us-male">American Male</option>
                        <option value="us-female">American Female</option>
                        <option value="au-male">Australian Male</option>
                        <option value="au-female">Australian Female</option>
                        <option value="ca-male">Canadian Male</option>
                        <option value="ca-female">Canadian Female</option>
                        <option value="in-male">Indian Male</option>
                        <option value="in-female">Indian Female</option>
                        <option value="za-male">South African Male</option> 
                        <option value="za-female">South African Female</option> 
                      </select>
                    {/* </div>

                    <div className="settings-section mt-4"> */}
                      <h3>Character Voice Profile Preference</h3>
                      <select
                        className="mt-2 p-2 border border-gray-300 rounded-md h-10"
                        value={selectedCharacterVoice}
                        onChange={(e) => setSelectedCharacterVoice(e.target.value)}
                      >
                        <option value="">Select Character Voice</option>
                        <option value="cartoon">Cartoon</option>
                        <option value="narrator">Narrator</option>
                      </select>
                    {/* </div>
                    <div className="settings-section mt-4"> */}
                    </div>

                    {/* Radio Button Group - Default STT (Complementary) & AI STT (Incurs Additional Cost) */}
                    <div className="settings-section mt-4">
                      <label className="flex items-center">
                        <input
                          type="checkbox"
                          checked={isVoiceNotesEnabled}
                          onChange={(e) => setIsVoiceNotesEnabled(e.target.checked)}
                          className="mr-4"
                        />
                        Enable Voice Input (STT - Speech To Text) in Notes
                      </label>
                    </div>

                    {/* Radio Button Group - Default STT (Complementary) & AI STT (Incurs Additional Cost) */}
                    { isVoiceNotesEnabled && (
                      <>
                      <div className="radio-group mb-4 flex flex-row">
                        <label className="flex items-center mb-2 text-black">
                          <input type="radio" name="sttChoice" value="Default STT" className="mr-4" />
                          Default STT - Web Speech (Complementary)
                        </label>
                        <label className="ml-8 flex items-center mb-2 text-black">
                          <input type="radio" name="sttChoice" value="AI STT" className="mr-4" />
                          AI STT (Incurs Additional Cost)
                        </label>
                      </div>

                      {/* AI Voice to Text */}
                      {/* {readSettings.sttChoice === 'AI STT' && ( */}
                        <div className="settings-section mt-4">
                          <h3 className="text-blue-800">AI Voice To Text</h3>
                          <div className="mt-2 flex flex-col">
                            <label htmlFor="voskSTT" className="ml-2">
                              <input type="radio" id="voskSTT" name="aistt" value="voskSTT" onChange={handleChange} className="ml-4" />
                              Vosk (AI)
                            </label>
                            <label htmlFor="deepspeechSTT" className="ml-2">
                              <input type="radio" id="deepspeechSTT" name="aistt" value="deepspeechSTT" onChange={handleChange} className="ml-4" />
                              DeepSpeech (AI)
                            </label>

                            <label htmlFor="whisperSTT" className="ml-2">
                              <input type="radio" id="whisperSTT" name="aistt" value="whisperSTT" onChange={handleChange} className="ml-4" />
                              OpenAI Whisper
                            </label>      

                            <label htmlFor="googleSTT" className="ml-2">
                              <input type="radio" id="googleSTT" name="aistt" value="googleSTT" onChange={handleChange} className="ml-4" />
                              Google
                            </label>            
                          </div>
                        </div>
                      {/* )} */}
                      </>
                    )}

                    {/* Radio Button Group - Think5Whys Smart Speaker */}
                    <div className="settings-section mt-4">
                      <label className="flex items-center">
                        <input
                          type="checkbox"
                          checked={isSmartSpeakerEnabled}
                          onChange={(e) => setIsSmartSpeakerEnabled(e.target.checked)}
                          className="mr-4"
                        />
                        Enable Thinky - The Think5Whys Smart Speaker
                      </label>
                    </div>

                    {/* Radio Button Group - Think5Whys Smart Speaker  */}
                    { isSmartSpeakerEnabled && (
                      <>
                      <div className="settings-section mt-4">
                        <h3>Speaker</h3>
                        <label className="flex items-center mb-2 text-black">
                          <input type="radio" name="ssChoice" value="Guddu" className="mr-4" />
                          Guddu Uncle
                        </label>
                        <label className="flex items-center mb-2 text-black">
                          <input type="radio" name="ssChoice" value="Kalam" className="mr-4" />
                          Kalam Uncle
                        </label>
                        <label className="flex items-center mb-2 text-black">
                          <input type="radio" name="ssChoice" value="Lobo" className="mr-4" />
                          Lobo Uncle
                        </label>
                        <label className="flex items-center mb-2 text-black">
                          <input type="radio" name="ssChoice" value="Gurpreet" className="mr-4" />
                          Gurpreet Uncle
                        </label>
                        <label className="flex items-center mb-2 text-black">
                          <input type="radio" name="ssChoice" value="Aunty" className="mr-4" />
                          Babita Aunty
                        </label>     
                        <label className="flex items-center mb-2 text-black">
                          <input type="radio" name="ssChoice" value="Munni" className="mr-4" />
                          Munni
                        </label> 
                        <label className="flex items-center mb-2 text-black">
                          <input type="radio" name="ssChoice" value="Munna" className="mr-4" />
                          Munna
                        </label>                                        
                      </div>
                      </>
                    )}

                    {/* Cloud Storage */}
                    <div className="settings-section mt-4">
                      <h3>Cloud Storage</h3>
                      <div className="text-black mt-2 flex flex-col">
                        <label htmlFor="personalCloud" className="ml-2">
                          <input type="radio" id="personalCloud" name="cloudStorage" value="Personal Cloud" onChange={handleChange} className="ml-4" />
                          Personal Cloud
                        </label>
                        {readSettings.cloudStorage === 'Personal Cloud' && (
                          <div className="sub-section text-black mt-2 flex flex-col">
                            <label htmlFor="googleDrive" className="ml-2">
                              <input type="radio" id="googleDrive" name="personalCloud" value="Google Drive" onChange={handleChange} className="ml-4" />
                              Google Drive
                            </label>

                            <label htmlFor="oneDrive" className="ml-2">
                              <input type="radio" id="oneDrive" name="personalCloud" value="OneDrive" onChange={handleChange} className="ml-4" />
                              OneDrive
                            </label>

                            <label htmlFor="dropBox" className="ml-2">
                              <input type="radio" id="dropBox" name="personalCloud" value="DropBox" onChange={handleChange} className="ml-4" />
                              DropBox
                            </label>
                          </div>
                        )}
                        <label htmlFor="think5WhysCloud" className="ml-2">
                          <input type="radio" id="think5WhysCloud" name="cloudStorage" value="Think5Whys Cloud" onChange={handleChange} className="ml-4" />
                          Think5Whys Cloud
                        </label>

                        <label htmlFor="privateCloud" className="ml-2">
                          <input type="radio" id="privateCloud" name="cloudStorage" value="Private Cloud" onChange={handleChange} className="ml-4" />
                          Private Cloud
                        </label>

                        <label htmlFor="governmentCloud" className="ml-2">
                          <input type="radio" id="governmentCloud" name="cloudStorage" value="Government Cloud" onChange={handleChange} className="ml-4" />
                          Government Cloud
                        </label>
                      </div>
                    </div>

                    <div className="flex flex-row mt-4 mb-4 justify-center">
                      <button
                        className="bg-purple-700 text-white py-2 px-4 rounded"
                        onClick={() => handleSaveSettings()}
                      >
                        Save Preferences
                      </button>
                      <button
                        className="bg-purple-700 text-white py-2 px-4 rounded ml-4"
                        onClick={handleSettingsClose}
                      >
                        Close
                      </button>
                    </div>
                    {errors && <p className="text-red-600">{errors}</p>}
                    {postedCommentMsg && <p>{postedCommentMsg}</p>}
                  </div>
                </div>
              </>
            )}
            {readCommentClicked && (
              <div
                  className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center text-sm"
                  style={{ zIndex: 1000 }}
                >
                  <div className="w-full h-full overflow-y-auto bg-blue-200 text-black border-b border-b-gray-300 p-4 rounded-md">
                    <div className="flex justify-center items-center text-blue-800 text-lg border-b">
                      <p className="text-yellow-600 mb-4 mt-4">
                        {sortedCommentData.length}  Comments/Notes on  
                        Page# {currentPageNumber} for the book {bookTitle}</p>
                    </div>
                    <div className="flex flex-row justify-center text-blue-800 text-sm border-b">
                      <button
                        className="py-2 ml-2 mt-2 w-20 bg-purple-800 text-white"
                        onClick={handleViewComment}
                      >
                        <FontAwesomeIcon icon={faComments} /> List
                      </button>
                      <button
                        className="py-2 ml-2 mt-2 w-32 bg-purple-800 text-white"
                        onClick={postComment}
                      >
                        <FontAwesomeIcon icon={faEdit} /> Add New 
                      </button>
                      <button
                        className="py-2 ml-2 mt-2 w-20 bg-purple-800 text-white"
                        onClick={handlePostClose}
                      >
                        <FontAwesomeIcon icon={faTimes} /> Close
                      </button>
                    </div>
                    {viewComment && (
                      <>
                        <div className="flex flex-row">
                          {/* Filter Dropdown */}
                          <div className="mb-4 flex flex-row items-center">
                            <label className="mr-2 text-gray-100 font-semibold">Filter By:</label>
                            <select
                              className="border border-gray-300 px-3 py-2 h-10 rounded-lg shadow-sm"
                              value={filterBy}
                              onChange={(e) => setFilterBy(e.target.value)}
                            >
                              <option value="All Notes">All Notes</option>
                              {[...new Set(sortedCommentData.map((item) => item.notesType))].map((type) => (
                                <option key={type} value={type}>
                                  {type}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="w-80"> 
                            <button
                              className="ml-2 mt-2 w-60 bg-purple-800 text-white"
                              onClick={() => generateCommentsPDF(bookTitle, pageNumber, sortedCommentData, userName)}
                            >
                              <FontAwesomeIcon icon={faFilePdf} /> Download as PDF
                            </button>
                          </div>
                        </div>
                        {filteredComments.length > 0 ? (
                          filteredComments.map((commentItem, commentIndex) => (
                            <div
                              key={commentIndex}
                              className="mb-2 p-6 bg-white shadow-xl rounded-lg border border-gray-200 hover:shadow-2xl transition-shadow duration-300"
                            >
                              <h4 className="text-lg font-bold text-gray-900">
                                {commentItem.notesType}
                              </h4>
                              <p className="text-m font-semibold text-blue-700">
                                {commentItem.notesTitle}
                              </p>
                              <p className="text-sm bg-white text-black">
                                <strong>Details:</strong>
                                <br />
                                <span dangerouslySetInnerHTML={{ __html: commentItem.notesText }} />
                              </p>
                              <div className="flex justify-start items-center mt-2 space-x-2">
                                <strong>Listen Notes In: </strong>
                                <select
                                  value={selectedLangCode}
                                  onChange={(e) => setSelectedLangCode(e.target.value)}
                                  className="px-2 py-2 h-10 border border-gray-300 rounded text-sm"
                                >
                                  {languageOptions.map((option) => (
                                    <option key={option.code} value={option.code}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>

                                {/* Play/Pause Button */}
                                <button
                                  className="text-sm mt-4 h-10 w-10 bg-green-600 text-white flex items-center justify-center rounded"
                                  onClick={() => listenNotesClicked(commentItem.notesText)}
                                >
                                  <FontAwesomeIcon icon={isNotesSpeaking ? faStop : faPlay} size="lg" />
                                </button>
                              </div>
                              {commentItem.isMoreInputs && (
                                <>
                                  <p className="text-sm text-gray-600">
                                     <strong>Subject: </strong>{commentItem.subjectName}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                     <strong>Book: </strong>{commentItem.bookName}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                     <strong>Chapter: </strong>{commentItem.chapter}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                     <strong>Chapter Section: </strong>{commentItem.chapterSection}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                     <strong>Chapter Sub Section: </strong>{commentItem.chapterSubSection}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                     <strong>Book Page#: </strong>{commentItem.bookPageNumber}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                    <strong >Is Self Study: </strong>
                                    {commentItem.isSelfstudyChecked ? (
                                      <span>Yes</span>
                                    ) : (
                                      "No"
                                    )}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                     <strong>Book: </strong>{commentItem.institution}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                     <strong>Teacher: </strong>{commentItem.teacherName}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                     <strong>Class: </strong>{commentItem.studyClass}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                     <strong>Section: </strong>{commentItem.sectionName}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                     <strong>Study Session: </strong>{commentItem.studySession}
                                  </p>
                                </>
                              )}
                              <div className="mt-2">
                                <p className="text-sm text-gray-600">
                                  <strong>Notes Remarks: </strong>{commentItem.notesRemarks}
                                </p>
                                <p className="text-sm text-gray-600">
                                  <strong>Sort Tags: </strong>{commentItem.sortTags}
                                </p>
                              </div>
                              <div className="flex justify-between items-center mt-2">
                                <p className="text-sm text-gray-600">
                                  <strong>Is Important: </strong>
                                  {commentItem.isImportant ? (
                                    <span className="text-red-600 font-semibold">Yes</span>
                                  ) : (
                                    "No"
                                  )}
                                  <strong className="ml-4">Is Visible to All: </strong>
                                  {commentItem.visibleToAll ? (
                                    <span className="text-green-600 font-semibold">Yes</span>
                                  ) : (
                                    "No"
                                  )}
                                </p>
                              </div>
                              <div className="flex flex-row mt-2">
                               <strong>By: </strong>
                                {commentItem.notesBy}
                                <strong className="ml-4">Date Posted: </strong>
                                {formatDateTime(commentItem.dateCreated)}
                              </div>
                              <div className="flex flex-row">
                                {/* <Tooltip text="Edit" position="top">
                                  <Link to={`/editpagecomment/${commentItem._id}`} className="h-10 w-10 text-blue-500 cursor-pointer hover:text-blue-700 flex items-center justify-center rounded"
                                  >
                                    <i className="fa-solid fa-pen text-lg"></i>
                                  </Link>
                                </Tooltip> */}
                                <Tooltip text="Edit" position="top">
                                  <span
                                    className="h-10 w-10 text-blue-500 cursor-pointer hover:text-blue-600 flex items-center justify-center rounded"
                                    onClick={() => editCommentClicked(commentItem._id)}
                                  >
                                    <i className="fa-solid fa-pen text-lg"></i>
                                  </span>
                                </Tooltip>
                                <Tooltip text="Delete this record" position="top">
                                  <span
                                    className="h-10 w-10 text-red-500 cursor-pointer hover:text-red-700 flex items-center justify-center rounded"
                                    onClick={() => deleteCommentClicked(commentItem._id)}
                                  >
                                    <i className="fa-solid fa-trash text-lg"></i>
                                  </span>
                                </Tooltip>
                                {isDeleteCommentClicked && (
                                  <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
                                    <div className="w-96 bg-white rounded-lg p-6 shadow-xl text-center">
                                      <p className="text-lg font-semibold mb-4 text-gray-100">
                                        Are you sure you want to delete this record?
                                      </p>
                                      <div className="flex justify-center space-x-4">
                                        <button
                                          className="bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700 transition-colors"
                                          onClick={() => handleDeleteComment(selectedCommentId)}
                                        >
                                          Confirm Delete
                                        </button>
                                        <button
                                          className="bg-gray-300 text-gray-100 py-2 px-4 rounded-lg hover:bg-gray-400 transition-colors"
                                          onClick={() => {
                                            setIsDeleteCommentClicked(false);
                                            setSelectedCommentId(null); 
                                          }}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                          </div>
                          ))
                        ) : (
                          <div className="mt-20 mb-20 flex justify-center text-center">
                            <p className="text-lg font-medium text-orange-500">
                              There are no Notes / Comments / Remarks for this Page!
                            </p>
                          </div>
                        )}
                      </>
                    )}
                    {(postCommentClicked || isEditCommentClicked) && (
                      <>
                          <div
                            className={`w-full flex flex-col shadow-md rounded-lg p-4 border ${
                              isEditCommentClicked
                                ? 'bg-orange-200 border-blue-300'
                                : 'bg-black border-gray-300'
                            }`}
                          >
                          { isEditCommentClicked ? (
                              <h3 className="text-lg font-semibold text-orange-600 mb-2">Edit Comment/Notes*</h3>
                          ) : (
                            <h3 className="text-lg font-semibold text-gray-100 mb-2">Add New Comment/Notes*</h3>
                          )}
                          <div className="mb-4">
                            <label className="text-sm text-gray-100 ml-1">Type*: </label>
                            <select
                              name="notesType"
                              id="notesType"
                              value={notesType}
                              defaultValue="Quick Notes"
                              onChange={(e) => setNotesType(e.target.value)}
                              className="w-full border rounded-md p-2 h-10 text-black"
                              style={{width: "300px"}}
                            >
                              {/* General Notes */}
                              <optgroup label="General Notes">
                                <option value="Chapter Summary">Chapter Summary</option>
                                <option value="Keywords">Keywords</option>
                                <option value="Notes for Exam">Notes for Exam</option>
                                <option value="Page Summary">Page Summary</option>
                                <option value="Quick Notes">Quick Notes</option>
                                <option value="Reference">Reference</option>
                                <option value="Section Summary">Section Summary</option>
                                <option value="Study Notes">Study Notes</option>
                              </optgroup>

                              {/* Academic Notes */}
                              <optgroup label="Academic Notes">
                                <option value="Assignment">Assignment</option>
                                <option value="Formula">Formula</option>
                                <option value="Mind Map">Mind Map</option>
                                <option value="Outlines">Outlines</option>
                                <option value="Past Questions">Past Questions</option>
                                <option value="Predict Outcome">Predict Outcome</option>
                                <option value="Project">Project</option>
                                <option value="Set Goal">Set Goal</option>
                                <option value="Solve Problem">Solve Problem</option>
                              </optgroup>

                              {/* Formula*/}
                              <optgroup label="Formula">
                                <option value="Formula">Formula</option>
                                <option value="Conversion">Conversion</option>
                                <option value="Outlines">Symbols</option>
                              </optgroup>

                              {/* Question Types */}
                              <optgroup label="Question Types">
                                <option value="My Own Questions">My Own Questions</option>
                                <option value="Previous Years Questions">Previous Years Questions</option>
                                <option value="Question - Comprehension">Comprehension</option>
                                <option value="Question - Fill Up The Blanks">Fill Up The Blanks</option>
                                <option value="Question - Long Answer Type">Long Answer Type</option>
                                <option value="Question - Matching">Matching</option>
                                <option value="Question - MCQ">Multiple Choice Question (MCQ)</option>
                                <option value="Question - Non-Numericals">Non-Numericals</option>
                                <option value="Question - Numericals">Numericals</option>
                                <option value="Question - Short Answer Type">Short Answer Type</option>
                                <option value="Question - True/False">True/False</option>
                                <option value="Teachers Questions">Teachers Questions</option>
                              </optgroup>

                              {/* Media & Experience-Based Notes */}
                              <optgroup label="Media & Experience-Based Notes">
                                <option value="Audio Notes">Audio Notes</option>
                                <option value="Evaluate Content">Evaluate Content</option>
                                <option value="Highlight">Highlight</option>
                                <option value="Image">Image</option>
                                <option value="Picture Flash Card">Picture Flash Card</option>
                                <option value="Sticky Note">Sticky Note</option>
                                <option value="Video">Video</option>
                              </optgroup>

                              {/* Actions & Appreciations */}
                              <optgroup label="Actions & Appreciations">
                                <option value="Appreciation">Appreciation</option>
                                <option value="Compare Concept">Compare Concept</option>
                                <option value="Experience">Experience</option>
                                <option value="Query">Query</option>
                                <option value="TODO Action Items">TODO / Kaizen Action Items</option>
                              </optgroup>

                              {/* VOGAB */}
                              <optgroup label="VOGAB">
                                <option value="Abbreviation">Abbreviation</option>
                                <option value="Acronym">Acronym</option>
                                <option value="Dictionary">Definition</option>
                                <option value="Dictionary">Dictionary</option>
                                <option value="Etymology">Etymology</option>
                                <option value="Glossary">Glossary</option>
                                <option value="Pronounciation">Pronounciation</option>
                                <option value="Sentences">Sentences</option>
                                <option value="Sentences">Sentences</option>
                                <option value="Translation">Translation</option>
                                <option value="Translation">Vocabulary</option>
                              </optgroup>
                              </select>
                          </div>
                          <div className="mb-4">
                            <label className="text-sm text-gray-100 ml-1">Title*: </label>
                            <input
                              type="text"
                              value={userCommentTitle}
                              onChange={(e) => setUserCommentTitle(e.target.value)}
                              placeholder="Input title"
                              className="w-full border rounded-md p-2 bg-gray-50"
                              style={{width: "90%"}}
                            />
                          </div>
                          <div className="mb-4">
                            <label htmlFor="isaudionotes" className="text-sm text-gray-100 ml-1">
                              <input
                                type="checkbox"
                                id="isAudioNotes"
                                checked={isAudioNotes}
                                onChange={handleIsAudioNotesChange}
                                className="mr-2"
                              />
                              Voice Input
                            </label>
                          </div>
                          {isAudioNotes && (
                            <>
                              <label htmlFor="conversationalNotes" className="text-sm text-gray-100 ml-1">
                                <input
                                  type="checkbox"
                                  id="showMicrophoneAlert"
                                  checked={showMicrophoneAlert}
                                  onChange={handleShowMicrophoneAlertCheckboxChange}
                                  className="mr-2"
                                />
                                Enable Microphone 🎤
                              </label>
                              {showMicrophoneAlert && (
                                <label htmlFor="conversationalNotes" className="text-sm text-gray-100 ml-1">
                                  <input
                                    type="checkbox"
                                    id="conversationalNotes"
                                    checked={isConversationalNotes}
                                    onChange={handleConversationalNotesCheckboxChange}
                                    className="mr-2"
                                  />
                                  Make it a Conversational Note (Powered by Think5Whys AI Partners)
                                </label>
                              )}
                            </>
                          )}
                          <div className="mb-4">
                            <label className="text-sm text-gray-100 ml-1">Notes/Comments/Remarks Details*: </label>
                            {showMicrophoneAlert ? (
                              <SpeechInputComponent
                                label="Notes Notes"
                                name="userCommentDetails"
                                value={userCommentDetails}
                                onChange={(e) => setUserCommentDetails(e.target.value)}
                                placeholder="Click Mic and Speak or Talk for Voice Input..."
                                maxLength="2000"
                                className="w-full border rounded-md p-2 bg-gray-50"
                              />
                            ) : (
                              <textarea
                                type="text"
                                name="userCommentDetails"
                                id="userCommentDetails"
                                value={userCommentDetails}
                                placeholder="Input here..."
                                onChange={(e) => setUserCommentDetails(e.target.value)}
                                maxLength="2000"
                                style={{
                                  border: '1px solid #ccc',
                                  padding: '2px',
                                  backgroundColor: '#f0f0f0',
                                  color: '#000000',
                                  maxWidth: '100%',
                                  height: '200px' // Set height to 200px
                                }}
                              />
                            )}
                          </div>

                          {/* Handwriting & Math OCR Section */}
                          <div className="mb-4 flex flex-col">
                            <div className="flex flex-row flex-wrap">
                              <button
                                className="mr-4 mb-2 w-auto bg-blue-500 text-white px-4 py-2 rounded-md"
                                onClick={handleToggleHandwriting}
                              >
                                {isHandwritingVisible ? "Hide Handwritten" : "Show Handwritten"}
                              </button>
                              <button className="mr-4 mb-2 w-auto bg-blue-500 text-white px-4 py-2 rounded-md" disabled={true} onClick={handleOpenHandwriting}>
                                Upload Image
                              </button>
                              {/* {isHandwritingVisible && (
                                <HandwritingToText onClose={handleCloseHandwriting} />
                              )} */}
                              <button className="mr-4 mb-2 w-auto bg-blue-500 text-white px-4 py-2 rounded-md" disabled={true} onClick={handleOpenHandwriting}>
                                Upload Video
                              </button>
                              {/* {isHandwritingVisible && (
                                <HandwritingToText onClose={handleCloseHandwriting} />
                              )} */}
                              <button className="mr-4 mb-2 w-auto bg-blue-500 text-white px-4 py-2 rounded-md" disabled={true} onClick={handleOpenHandwriting}>
                                Upload Audio
                              </button>
                            </div>
                            {/* <div>
                              {isHandwritingVisible && (
                                <HandwrittenNote onClose={handleToggleHandwriting} />
                              )}
                            </div> */}
                            <div>
                              {isHandwritingVisible && (
                                <HandwrittenNote 
                                  onClose={handleToggleHandwriting} 
                                  pageNumber={currentPageNumber}
                                  bookTitle={bookTitle}
                                />
                              )}
                            </div>
                            <div>
                              {/* {isHandwritingVisible && (
                                <HandwritingToText onClose={handleCloseHandwriting} />
                              )} */}
                              {/* <button className="mb-2 w-auto bg-blue-500 text-white px-4 py-2 rounded-md" disabled={true} onClick={handleOpenMathOCR}>
                                Open Handwritten Math Formula to Text
                              </button>
                              {isMathOCRVisible && (
                                <MathOCR onClose={handleCloseMathOCR} />
                              )} */}
                            </div>
                          </div>

                          {/* AI Support Section */}
                          <div className="mb-4">
                            <label className="text-sm text-gray-100 ml-1">
                              <input
                                type="checkbox"
                                checked={isCheckedAISupport}
                                onChange={(e) => setIsCheckedAISupport(!isCheckedAISupport)}
                                className="mr-2"
                              />
                              I want to take Gen AI Support for generating my AI Prompt.
                            </label>
                            {isCheckedAISupport && userCommentDetails !== '' && (
                              <div className="mt-2">
                                {/* <AILightComponent param1={notesType} param2={' Notes/Comments/Remarks Title: ' + userCommentTitle + ', Details: ' + userCommentDetails} /> */}
                                    <AILightComponent
                                        mode="study_notes_enhancer"
                                        notesType={notesType}
                                        param1={`Note Type: ${notesType}`}
                                        param2={`Title: ${userCommentTitle}
                                        Details: ${userCommentDetails}`}
                                      />
                              </div>
                            )}
                          </div>

                          <div className="flex">
                            <label htmlFor="isMoreInputs" className="text-sm text-gray-100 ml-1">
                              <input
                                type="checkbox"
                                id="isMoreInputs"
                                checked={isMoreInputs}
                                onChange={handleMoreInputsCheckboxChange}
                                className="mr-2"
                              />
                              More Inputs (Mostly Used in Academic)....
                            </label>
                          </div>
                          {isMoreInputs && (
                            <div className="mb-4 text-sm border-1 border-green-400">
                                <p className="ml-4 text-sm text-gray-100">Subject: </p>
                                <input
                                  className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                                  style={{ width: "400px" }}
                                  value={subjectName}
                                  onChange={(e) => setSubjectName(e.target.value)}
                                  placeholder="Input Subject Name"
                                />
                                <p className="ml-4 text-sm text-gray-100">Book Name: </p>
                                  <input
                                    className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                                    style={{ width: "90%" }}
                                    value={bookName}
                                    onChange={(e) => setBookName(e.target.value)}
                                    placeholder="Input Book Name"
                                  />
                                  <p className="ml-4 text-sm text-gray-100">Chapter: </p>
                                  <input
                                    className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                                    style={{ width: "500px" }}
                                    value={chapter}
                                    onChange={(e) => setChapter(e.target.value)}
                                    placeholder="Input chapter name"
                                  />
                                  <p className="ml-4 text-sm text-gray-100">Section Name: </p>
                                  <input
                                    className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                                    style={{ width: "400px" }}
                                    value={chapterSection}
                                    onChange={(e) => setChapterSection(e.target.value)}
                                    placeholder="Input Chapter Section"
                                  />
                                  <p className="ml-4 text-sm text-gray-100">Sub-section: </p>
                                  <input
                                    className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                                    style={{ width: "400px" }}
                                    value={chapterSubSection}
                                    onChange={(e) => setChapterSubSection(e.target.value)}
                                    placeholder="Input Chapter Sub Section"
                                  />
                                  <p className="ml-4 text-sm text-gray-100">Book Page#: </p>
                                  <input
                                    className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                                    style={{ width: "50px" }}
                                    value={bookPageNumber}
                                    onChange={(e) => setBookPageNumber(e.target.value)}
                                  />
                                  <p className="ml-4">
                                  <label htmlFor="isSelfstudy" className="text-sm text-gray-100">
                                    <input
                                      type="checkbox"
                                      id="isSelfstudy"
                                      checked={isSelfstudyChecked}
                                      onChange={handleIsSelfstudyCheckboxChange}
                                      className="mr-2"
                                    />
                                    This is Self-study Note
                                  </label>
                                  </p>
                                  <p className="ml-4 text-sm text-gray-100">Institution Name / Code: </p>
                                  <input
                                    className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                                    style={{ width: "400px" }}
                                    value={institution}
                                    onChange={(e) => setInstitution(e.target.value)}
                                  />
                                  <p className="ml-4 text-sm text-gray-100">Teacher Name / Code: </p>
                                  <input
                                    className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                                    style={{ width: "300px" }}
                                    value={teacherName}
                                    onChange={(e) => setTeacherName(e.target.value)}
                                  />
                                  <p className="ml-4 text-sm text-gray-100">Class: </p>
                                  <input
                                    className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                                    style={{ width: "200px" }}
                                    value={studyClass}
                                    onChange={(e) => setStudyClass(e.target.value)}
                                  />
                                  <p className="ml-4 text-sm text-gray-100">Section: </p>
                                  <input
                                    className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                                    style={{ width: "200px" }}
                                    value={sectionName}
                                    onChange={(e) => setSectionName(e.target.value)}
                                  />
                                  <p className="ml-4 text-sm text-gray-100">Session: </p>
                                  <input
                                    className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                                    style={{ width: "200px" }}
                                    value={studySession}
                                    onChange={(e) => setStudySession(e.target.value)}
                                  />
                                  
                            </div>
                          )}
                          {/* Important and Visibility Checkboxes */}
                          <div className="flex">
                            <label htmlFor="important" className="text-sm text-gray-100 ml-1">
                              <input
                                type="checkbox"
                                id="important"
                                checked={isImportantChecked}
                                onChange={handleImportantCheckboxChange}
                                className="mr-2"
                              />
                              Is Important
                            </label>
                          </div>
                          <div className="mb-2 flex ">
                            <label htmlFor="visibleToAll" className="text-sm text-gray-100 ml-1">
                              <input
                                type="checkbox"
                                id="visibleToAll"
                                checked={isVisibleToAllChecked}
                                onChange={handleVisibleToAllCheckboxChange}
                                className="mr-2"
                              />
                              Visible to All
                            </label>
                          </div>
                          <div>
                            <p className="text-sm mt-2 ml-4 text-gray-100">Notes Remarks: </p>
                            <input
                                className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                                style={{ width: "90%" }}
                                value={notesRemarks}
                                onChange={(e) => setNotesRemarks(e.target.value)}
                            />
                             <p className="text-sm ml-4 text-gray-100">Sort Tags: </p>
                              <input
                                className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                                style={{ width: "90%" }}
                                value={sortTags}
                                onChange={(e) => setSortTags(e.target.value)}
                              />
                          </div>
                      
                          <div className="mb-4">
                            {errors && !postedComment && (
                              <p className="text-red-600">{errors}</p>
                            )}
                            {postedCommentMsg && <p className="text-green-600">{postedCommentMsg}</p>}
                          </div>
                          {postCommentClicked && (
                            <div className="flex justify-strat">
                              <button
                                className="bg-blue-700 text-white p-2"
                                onClick={() =>
                                  handlePostComment(
                                    userCommentTitle,
                                    userCommentDetails,
                                    notesType,
                                    isImportantChecked,
                                    isVisibleToAllChecked,
                                    currentPageNumber,
                                    bookTitle,
                                    notesRemarks,
                                    sortTags,
                                    isMoreInputs,
                                    subjectName,
                                    bookName,
                                    chapter,
                                    chapterSection,
                                    chapterSubSection,
                                    bookPageNumber,
                                    institution,
                                    teacherName,
                                    studyClass,
                                    sectionName,
                                    studySession,
                                    isSelfstudyChecked
                                  )
                                }
                                disabled={postedComment} 
                                style={{ maxWidth: "150px" }}
                              >
                                {postedComment ? "Posted..." : "Post"}  
                              </button>
                            </div>
                          )}
                          {isEditCommentClicked && (
                            <div className="flex justify-strat">
                              <button
                                className="bg-purple-700"
                                onClick={() =>
                                  handleEditComment(
                                    selectedCommentId,
                                    userCommentTitle,
                                    userCommentDetails,
                                    notesType,
                                    isImportantChecked,
                                    isVisibleToAllChecked,
                                    currentPageNumber,
                                    bookTitle,
                                    notesRemarks,
                                    sortTags,
                                    isMoreInputs,
                                    subjectName,
                                    bookName,
                                    chapter,
                                    chapterSection,
                                    chapterSubSection,
                                    bookPageNumber,
                                    institution,
                                    teacherName,
                                    studyClass,
                                    sectionName,
                                    studySession,
                                    isSelfstudyChecked
                                  )
                                }
                                disabled={postedComment} 
                                style={{ maxWidth: "150px" }}
                              >
                                {postedComment ? "Updated..." : "Update"}  
                              </button>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
            )}
            {bookLinkClicked && (
              <>
              <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center" style={{ zIndex: 1000 }}>
                <div className="w-full h-full overflow-y-auto bg-blue-200 text-black border-b border-b-gray-300 p-4 rounded-md">
                  <div className="flex justify-center">
                    <p className="text-yellow-800 text-lg">External Links/URLs of the Books {bookTitle}, Page Number {currentPageNumber}</p>
                  </div>
                  <div className="flex justify-center mt-4">
                    <button
                      className="bg-green-700 p-2 w-20"
                      onClick={handleListLinkButtonClick}
                      // style={{ width: "150px" }}
                    >
                      List
                    </button>
                    <button
                      className="bg-green-700 ml-2 px-2 w-20"
                      onClick={handleAddNewLinkButtonClick}
                      // style={{ width: "150px" }}
                    >
                      Add New
                    </button>
                    <button
                      className="bg-green-700 ml-2 p-2 w-20"
                      onClick={handleCloseLinkButtonClick}
                      // style={{ width: "150px" }}
                    >
                      Close
                    </button>
                  </div>
                  {listLink && (
                    <div className="flex flex-col justify-center p-8 bg-gray-50 [&_p]:text-black min-h-screen">
                      {sortedListLinkData.length > 0 ? (
                        sortedListLinkData.map((linkItem, linkIndex) => (
                          <div key={linkIndex} className="flex flex-col items-start w-full mb-6 p-6 bg-white border border-gray-300 shadow-lg rounded-lg transition-transform transform hover:scale-105">
                            <p className="text-xl font-semibold text-gray-900 mb-2">
                              <strong>Link/Site Name:</strong> {linkIndex + 1}. {linkItem.linkName}
                            </p>
                            <p className="text-lg text-gray-100 mb-2">
                              <strong>Page/Channel Name:</strong> {linkItem.linkPageName}
                            </p>
                            <p className="text-lg text-gray-100 mb-2">
                              <strong>URL/Link Address:</strong> 
                              <a
                                href={linkItem.linkAddress}
                                className="text-blue-600 underline hover:text-blue-800"
                                onClick={(e) => {
                                  e.preventDefault();
                                  accessSite(linkItem.linkAddress);
                                }}
                              >
                                {linkItem.linkAddress}
                              </a>
                            </p>
                            <p className="text-lg text-gray-100">
                              <strong>Details:</strong> {linkItem.linkDetails}
                            </p>
                            <div className="flex items-center mt-4">
                              <Tooltip text="Delete this record" position="top">
                                <span className='text-red-600 cursor-pointer mr-2' onClick={() => deleteLinkClicked()}>
                                  <i className="fa-solid fa-trash"></i>
                                </span>
                              </Tooltip>
                              {isDeleteLinkClicked && (
                                <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center">
                                  <div className="bg-white p-6 rounded-lg shadow-lg w-80 text-center">
                                    <p className="mb-4 text-lg font-semibold text-gray-100">Are you sure you want to delete this record?</p>
                                    <div className="flex justify-center">
                                      <button
                                        className="bg-red-600 text-white py-2 px-4 rounded-lg mr-4 hover:bg-red-700 transition-colors"
                                        onClick={() => handleDeleteLink(linkItem._id)}
                                      >
                                        Confirm Delete
                                      </button>
                                      <button
                                        className="bg-gray-300 text-gray-100 py-2 px-4 rounded-lg hover:bg-gray-400 transition-colors"
                                        onClick={() => noDeleteLinkClicked()}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="mt-20 mb-20 flex justify-center text-center">
                          <p className="text-lg text-blue-600 font-medium">
                            <span className="text-orange-600">There are no Link/Page URLs for this Page!</span>
                          </p>
                        </div>
                      )}
                    </div>
                  )}

                  {addNewLink && (
                    <div className="text-sm [&_p]:text-black">
                      <p className="ml-4">Link/Site Name*: </p>
                      <input
                        className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                        style={{ width: "50%" }}
                        value={linkName}
                        onChange={(e) => setLinkName(e.target.value)}
                        placeholder="Input link name"
                      />
                      <p className="ml-4">Channel/Page Name*: </p>
                      <input
                        className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                        style={{ width: "50%" }}
                        value={linkPageName}
                        onChange={(e) => setLinkPageName(e.target.value)}
                        placeholder="Input Page/Channel Name"
                      />
                      <p className="ml-4">Link Title*: </p>
                      <input
                        className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                        style={{ width: "70%" }}
                        value={linkTitle}
                        onChange={(e) => setLinkTitle(e.target.value)}
                        placeholder="Input title"
                      />
                      <p className="ml-4">Link Address/URL*: </p>
                      <input
                        className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                        style={{ width: "90%" }}
                        value={linkAddress}
                        onChange={(e) => setLinkAddress(e.target.value)}
                        placeholder="Input/Copy-Paste address"
                      />
                      <p className="ml-4">
                      <label htmlFor="isvideo" className="text-sm text-black">
                        <input
                          type="checkbox"
                          id="isvideo"
                          checked={isVideoChecked}
                          onChange={handleIsVideoCheckboxChange}
                          className="mr-2"
                        />
                        Is Video*
                      </label>
                      </p>
                      <p className="mt-2 ml-4">About the Link: </p>
                      <textarea
                        className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                        style={{ height: "200px", width: "90%" }}
                        value={linkDetails}
                        onChange={(e) => setLinkDetails(e.target.value)}
                        placeholder="Input details"
                      />

                      <div className="ml-4 mr-r mb-4 flex flex-col">
                        {errors && <p className="text-red-600">{errors}</p>}
                        {bookLinkSaved && <p>{bookLinkSavedMsg}</p>}
                        <button
                          className="bg-purple-700"
                          onClick={() =>
                            handleSaveBookLink(
                              linkName,
                              linkPageName,
                              linkTitle,
                              linkAddress,
                              isVideoChecked,
                              linkDetails,
                              currentPageNumber
                            )
                          }
                          disabled={saveBookLinkToBeDisabled && bookLinkSaved}
                          style={{ maxWidth: "150px" }}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              </>
            )}
          </>
        )}
      </div>
    // )}
    // </div>
  );
};

export default ReadBook;
